// extracted by mini-css-extract-plugin
export default {"wrapper":"DualImage_wrapper__fZm06","image":"DualImage_image__4HmIX"};